
const lbaGrid = angular.module('app.lbaGrid', ['ngTasty', 'ui.sortable']);

lbaGrid.controller('lbaGridCtrl', require('./lbaGridCtrl'));
lbaGrid.controller('lbaDeleteConfirmCtrl', require('./lbaDeleteConfirmCtrl'));
lbaGrid.directive('lbaGrid', require('./lbaGridDir'));

export default lbaGrid;



// WEBPACK FOOTER //
// ./src/components/lbaGrid/index.js